import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FiMail, FiLock, FiArrowLeft } from 'react-icons/fi';

export default function ForgotPassword() {
  const [step, setStep] = useState(1); // 1=email, 2=code+newpass
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      toast.success('If an account exists, a reset code has been sent');
      setStep(2);
    } catch {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { email, code, newPassword });
      toast.success('Password reset! You can now log in.');
      setStep(3);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--accent)', marginBottom: 4 }}>ReplyCraft</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Reset your password</p>
        </div>

        {step === 1 && (
          <form onSubmit={handleSendCode} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={styles.inputGroup}>
              <FiMail style={styles.inputIcon} />
              <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required style={styles.input} />
            </div>
            <button type="submit" disabled={loading} style={styles.btn}>{loading ? 'Sending...' : 'Send Reset Code'}</button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <input type="text" placeholder="6-digit code" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} maxLength={6} style={styles.codeInput} />
            <div style={styles.inputGroup}>
              <FiLock style={styles.inputIcon} />
              <input type="password" placeholder="New password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required style={styles.input} />
            </div>
            <button type="submit" disabled={loading} style={styles.btn}>{loading ? 'Resetting...' : 'Reset Password'}</button>
          </form>
        )}

        {step === 3 && (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'var(--success)', marginBottom: 16, fontSize: 16 }}>Password reset successfully!</p>
            <Link to="/login" style={styles.btn}>Go to Login</Link>
          </div>
        )}

        <p style={{ textAlign: 'center', marginTop: 24 }}>
          <Link to="/login" style={{ color: 'var(--text-secondary)', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
            <FiArrowLeft /> Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', padding: 20 },
  card: { width: '100%', maxWidth: 420, background: 'var(--bg-secondary)', borderRadius: 16, padding: '40px 32px', border: '1px solid var(--border)' },
  inputGroup: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputIcon: { position: 'absolute', left: 14, color: 'var(--text-muted)', fontSize: 18 },
  input: { width: '100%', padding: '14px 14px 14px 44px', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-primary)', fontSize: 15, outline: 'none' },
  codeInput: { width: '100%', padding: 16, background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-primary)', fontSize: 24, textAlign: 'center', letterSpacing: 12, outline: 'none', fontWeight: 700 },
  btn: { display: 'block', width: '100%', padding: 14, background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer', textAlign: 'center', textDecoration: 'none' }
};
